import { useContext, useEffect, useState } from 'react';
import { UserContext } from '@adflow/utils';

export const TEMPLATE_WEBMCP_FEATURE = 'cm-template-webmcp';

export function useTemplateWebMCPFeature(): boolean {
  const { user } = useContext(UserContext);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const checkFeature = async () => {
      const hasFeature = (await user?.hasFeature(TEMPLATE_WEBMCP_FEATURE)) ?? false;
      if (!cancelled) {
        setEnabled(hasFeature);
      }
    };
    checkFeature().catch((error) => {
      console.warn('Failed to check template builder WebMCP feature', error);
      if (!cancelled) {
        setEnabled(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return enabled;
}
